import { ACTION_CORE_API_SUB_DUMP, ACTION_CORE_API_SUB_UPDATE, AppAction, updateSimpleStore } from '@om-fe/store';
import { getTopBetsTimeRangeSliceName } from './time-range-nav.utils';
import { TimeRangeModel } from '../../utils/top-bets.model';
import { TimeRangeType, TopBetsTimeRangeActions } from '../../utils/top-bets.constants'

export interface TimeRangeListItemModel {
    readonly id: string;
    readonly displayName: string;
    readonly position: string;
    readonly timeRangeType: TimeRangeType;
    readonly value: number;
}
export interface TimeRangeListStateModel {
    readonly ready: boolean;
    readonly items: Record<string, TimeRangeListItemModel>;
    readonly list: string[];
    readonly disciplineId: string;
    readonly locationId?: string;
    readonly categoryId?: string;
}

const initialState: TimeRangeListStateModel = {
    ready: false,
    list: [],
    items: {},
    disciplineId: '',
    locationId: undefined,
    categoryId: undefined,
};


export const timeRangeNavReducerCreator = (instanceId: string) => (
    state: TimeRangeListStateModel = initialState,
    action: AppAction,
): TimeRangeListStateModel => {
    const slice: string = getTopBetsTimeRangeSliceName(instanceId);

    const { meta, payload } = action;
    
    if (!meta || meta.slice !== slice) {
        return state;
    }
    
    switch (action.type) {
        case TopBetsTimeRangeActions.SetFilterData: {

            return {
                ...state,
                disciplineId: payload.disciplineId,
                locationId: payload.locationId,
                categoryId: payload.categoryId,
            };
        }
        case ACTION_CORE_API_SUB_DUMP: {
            const items: Record<string, TimeRangeListItemModel> = {};
            const { records } = payload;

            const list: string[] = records.map((item: TimeRangeModel): string => {
                const {
                    id,
                    displayName,
                    position,
                    timeRangeType,
                    value,
                } = item;

                items[id] = {
                    id,
                    displayName,
                    position,
                    timeRangeType,
                    value,
                };

                return id;
            });
            
            return {
                ...state,
                ready: true,
                list,
                items,
            };
        }
        case ACTION_CORE_API_SUB_UPDATE: {

            return updateSimpleStore<TimeRangeModel, TimeRangeListItemModel, TimeRangeListStateModel>(state, payload, {
                id: 'id',
                displayName: 'displayName',
                position: 'position',
                timeRangeType: 'timeRangeType',
                value: 'value',
            });
        }
        default:
            return state;
    }
};

